import { useUserStore } from '../../store/useUserStore';
import { useNavigate } from 'react-router-dom';
import Url from '../../data/url';
import { useAllVideosQuery } from '../../queries';
import IcChevronRight from '../../assets/image/ic_chevron_right.svg';
import ImgNoThumbnail from '../../assets/image/img_video_no_thumbnail.png';

function AllVideos() {
  const navigate = useNavigate();
  const user = useUserStore();

  const { data: videos = [] } = useAllVideosQuery(user?.id, { enabled: !!user?.id });

  return (
    <>
      <div className="w-full flex items-center justify-between py-[16px] px-[20px]">
        <div className="text-[18px] font-[700] text-[#1C1C1C]">전체보기</div>
        <button
          type="button"
          className="flex items-center justify-center cursor-pointer"
          onClick={() => navigate(Url.HistoryAllVideos)}
        >
          <div className="flex items-center text-[14px] font-[400] text-[#767676]">더보기</div>
          <img src={IcChevronRight} alt="더보기 아이콘" className="w-[16px] h-[16px] ml-[4px]" />
        </button>
      </div>
      <div className="flex items-center justify-start overflow-x-auto pb-2">
        <div className="shrink-0 inline-flex items-center justify-start gap-2 px-[20px]">
          {videos?.length >= 1 &&
            videos?.map((video, index) => (
              <button
                type="button"
                onClick={() =>
                  navigate(Url.HistoryWatchVideo, { state: { videos, videoIndex: index } })
                }
                key={video.mediaId}
                className="shrink-0 w-[174px] h-[220px] bg-[#F8F8F8] rounded-[10px] flex items-center justify-center text-[#1C1C1C] text-[14px] font-[500]"
              >
                <img
                  src={video?.thumbnailUrl ?? ImgNoThumbnail}
                  alt={`Video ${video.mediaId}`}
                  className="w-full h-full rounded-[10px] object-cover"
                />
              </button>
            ))}
        </div>
      </div>
    </>
  );
}

export default AllVideos;
